import i18n from "../../../i18n";

export const instancesFields = [
    {
        key: "name",
        label: i18n.t("instances.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "versionNumber",
        label: i18n.t("instances.version"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "totalLicences",
        label: i18n.t("instances.licences"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "totalDevices",
        label: i18n.t("instances.players"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "totalDevicesWithSolution",
        label: i18n.t("instances.playersSolutions"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    }
];
